import { defineComponent as _defineComponent } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { computed, ref } from 'vue'
import BulkUpdateWrapper from '@/components/common/BulkUpdateWrapper.vue'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { useAddJobsToInvoiceMutation } from '@/api/invoice'
import BatchesList from '@/components/batches/BatchesList.vue'
import { useRoute, useRouter } from 'vue-router/composables'
import BatchCreationForm from '@/components/batches/BatchCreationForm.vue'
import { SnackType } from '@/components/vision/SnackBarType'


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkAddJobsToBatchForm',
  props: {
    buttonLabel: null,
    selectedJobs: null
  },
  emits: ["dismiss", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buttonLabel: string
  selectedJobs: JobJson[]
}





const route = useRoute()
const router = useRouter()

const hubId = computed(() =>
  props.selectedJobs.length > 0 ? props.selectedJobs[0].hub_id : ''
)

const {
  mutateAsync: addJobsToBatch,
  isLoading: addingJobsToBatch,
  error: addJobsToBatchError,
} = useAddJobsToInvoiceMutation()

const batchesListRef = ref()
const selectedBatchId = ref<string | null | undefined>()
const snackbarMessage = ref()
const hasChanges = computed(() => !!selectedBatchId.value)
const currentSearchQuery = ref('')
const showCreateBatchForm = ref(false)
const isSnackbarVisible = ref(false)
const snackbarType = ref(SnackType.ERROR)
const onSelect = async (newBatchId: string) => {
  selectedBatchId.value = newBatchId
  await saveJobs()
}

const saveJobs = async () => {
  if (!selectedBatchId.value) {
    return
  }
  try {
    await addJobsToBatch({
      id: selectedBatchId.value,
      jobIds: props.selectedJobs.map((job) => job.id),
    })
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, { invoice_id: selectedBatchId.value })
    )
    emits('updated', {
      message: 'Batch updated',
      updatedJobs,
    })
    isSnackbarVisible.value = false
    await router.push({
      name: `${route.name}-batches-info-panel`,
      params: {
        batchId: selectedBatchId.value,
      },
    })
  } catch (err) {
    snackbarType.value = SnackType.ERROR
    isSnackbarVisible.value = true
    snackbarMessage.value = addJobsToBatchError.value
  }
}

const handleBatchCreatedSuccess = async (data: {
  batchId: string
  batchNumber: string | null
}) => {
  selectedBatchId.value = data.batchId
  await saveJobs()
}

const handleBatchCreatedFailure = async (error: unknown) => {
  snackbarType.value = SnackType.ERROR
  isSnackbarVisible.value = true
  snackbarMessage.value = error
}

const handleOpenCreateBatchForm = (newSearchQuery: string) => {
  showCreateBatchForm.value = true
  currentSearchQuery.value = newSearchQuery
}

const dismiss = () => emits('dismiss')

return { __sfc: true,emits, props, route, router, hubId, addJobsToBatch, addingJobsToBatch, addJobsToBatchError, batchesListRef, selectedBatchId, snackbarMessage, hasChanges, currentSearchQuery, showCreateBatchForm, isSnackbarVisible, snackbarType, onSelect, saveJobs, handleBatchCreatedSuccess, handleBatchCreatedFailure, handleOpenCreateBatchForm, dismiss, BulkUpdateWrapper, BatchesList, BatchCreationForm }
}

})